export default __webpack_public_path__ + "static/media/error.c04cb620.svg";